<template>
    <div v-if="(count>0) || !isloading" role="main" class="searchResultsContainer col-lg-8">
      <c-notification-bar></c-notification-bar>
      <c-search-results-header :count="count" :searchTerm="searchTerm"></c-search-results-header>
      <div class="row justify-content-between">
        <c-mobile-filter-toggle @click="onFilterToggle"></c-mobile-filter-toggle>
        <p class="visuallyhidden" tabindex="0">The search results will continuously load as you tab down the page, to exit the search results press the esc key. This will take you to the page footer</p>
        <c-search-results-sort-by
          :buttonText="sortByButtonText"
          :options="sortOptions"
          @input="onSortByInput"
          :value="sortBy"
        ></c-search-results-sort-by>
       
        <c-filter v-if="mobileFilterShow" :location="location" @filter-selected="onFilterSelected"></c-filter>

      </div>
      <hr />
      <c-search-results-articles
        :articles="articles"
        @infinite="onInfinite"
      ></c-search-results-articles>
    </div>
    <!-- what to show when count is 0 -->
    <div v-else role="main" class="searchResultsContainer col-lg-8 noResults">
      <div class="c-chathams header header--heavy">
        <h1 class="BPoR-heading BPoR-filter-heading"> 
            We’re sorry we were not able to find any matches to '{{searchTerm}}'.
        </h1>
        <c-mobile-filter-toggle @click="onFilterToggle"></c-mobile-filter-toggle>
        <c-filter v-if="mobileFilterShow" :location="location" @filter-selected="onFilterSelected"></c-filter>
        <br>
        <p class="BPoR-filter-content">
          You could try an alternative search, use our <a href=/results/a-z-conditions>conditions list</a> or <a :href=redirectLink >{{browseString}}</a> {{onOurService}} 
        </p>
        <p class="BPoR-filter-content">
          <a href="https://volunteer.bepartofresearch.nihr.ac.uk/participants/introduction" target="_blank" aira-label="register now to be contacted directly about research opportunities">Register now</a> to be contacted directly about research opportunities.
        </p>
      </div>

  </div>
<!-- </div> -->
</template>

<script>
import MobileFilterToggle from '@/components/pages/searchResults/MobileFilterToggle.vue'
import SearchResultsArticles from '@/components/pages/searchResults/SearchResultsArticles.vue'
import SearchResultsHeader from '@/components/pages/searchResults/SearchResultsHeader.vue'
import SearchResultsSortBy from '@/components/pages/searchResults/SearchResultsSortBy.vue'
import LoadingSpinner from '@/components/pages/LoadingSpinner.vue'
import { title } from '@/utilities/filters'
import { searchResults } from '@/components/pages/searchResults/SearchResultsHelpers'
import { isloaded } from '@/components/pages/searchResults/SearchResultsHelpers'
import WelshNotification from '@/components/pages/filter/WelshNotification.vue'
import { handleFilterSelected, fetch } from '@/views/results/resultsHelpers'




export default {
  components: {
    'c-notification-bar': WelshNotification,
    'c-mobile-filter-toggle': MobileFilterToggle,
    'c-search-results-articles': SearchResultsArticles,
    'c-search-results-header': SearchResultsHeader,
    'c-search-results-sort-by': SearchResultsSortBy,
    'c-loading-spinner':LoadingSpinner,
  },
  computed: {
    mobileFilterShow(){
      return this.$store.getters['search/showFilterOnMobile'];
    },
    isloading(){
      return this.getIsLoaded
    },
    getIsLoaded(){
      return isloaded(this)
    },
    redirectLink(){
      return "/results/search-results?query=&location=" + (new URL(document.location)).searchParams.get("location");
    },
    location(){
        return  (new URL(document.location)).searchParams.get("location");
    },
    location() {
      return this.$route.query.location || ''
    },
    articles() {
      return this.searchResults.articles
    },
    count() {
      return this.searchResults.count
    },
    params() {
      return this.$store.getters['search/params']
    },
    searchResults() {
      return searchResults(this)
    },
    searchTerm() {
      return this.params.query && this.params.query !== '*' ? this.params.query : ''
    },
    sortBy() {
      return this.$store.getters['search/sortBy']
    },
    queryParams() {
      return this.$store.getters['search/params']
    },
    sortByButtonText() {
      return this.sortOptions.find(o => o.value === this.sortBy)?.text
    },
    sortOptions() {
      const hasLoc = this.$store.getters['search/hasLocation']
      const loc = hasLoc ? [{ text: title(this.$t('common.distance')), value: 'distance' }] : []
      return [
        { text: title(this.$t('ui.relevance')), value: 'relevance' },
        ...loc,
        { text: title(this.$t('ui.mostRecent')), value: 'mostRecent' },
        { text: `${title(this.$t('common.title'))} A-Z`, value: 'titleAZ' },
      ]
    },
      browseString(){
      if((new URL(document.location)).searchParams.get("location")){
          return `browse the studies happening near you`
      }else{
        return `browse the most recent studies.`
      }   
    },
    onOurService(){
     if((new URL(document.location)).searchParams.get("location")){
      return "on our service."
    }
    return
    },
  },

  methods: {
    onFilterSelected(e) {
      handleFilterSelected(this, e)
    },
    onFilterToggle(e) {
      const { commit, getters } = this.$store
      commit('search/setShowFilterOnMobile', !getters['search/showFilterOnMobile'])
      this.$nextTick(() => {
        try{
          document.getElementById("theFirstCategory").focus();
        }catch(err){
          console.dir(err.value)
        }
      });
    },
    async onInfinite(e) {
      this.$store.dispatch('search/fetchMore', e)
    },
    onSortByInput(e) {
      this.$store.commit('search/setSortBy', e)
      this.$emit('sort', e)
    },
  },

}
</script>
